//change this
export const TIMEOFFSET = new Date().getTimezoneOffset();

export enum PasswordErrors {
  TOO_SHORT = "Password should be at least 8 characters long.",
  TOO_LONG = "Password should be no more than 20 characters long.",
  ONE_LOWERCASE = "Password should contain at least one lowercase letter.",
  ONE_UPPERCASE = "Password should contain at least one uppercase letter.",
  ONE_NUMBER = "Password should contain at least one number.",
  ONE_SPECIAL = "Password should contain at least one special character.",
}
